import React from "react";

export const ConditionalContainer = ({ children, condition }) =>
  condition ? <>{children}</> : <></>;

ConditionalContainer.defaultProps = { condition: true };
